import { render } from "./BoardInfo.vue?vue&type=template&id=055cd7a6"
import script from "./BoardInfo.vue?vue&type=script&lang=js"
export * from "./BoardInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__